import React, { useContext, useEffect, useState } from 'react'
import { VirtualMachineService } from '../../services/VirtualMachine'
import { Context } from '../../Context'
import { FaPowerOff, FaRedo, FaPause, FaInfoCircle, FaUndo } from 'react-icons/fa'
import './styles.scss'

const RemoteClientManager = ({
  isConnected,
  vmName,
  onStateMessage,
  updateVmDetails,
  shoudlReconnect,
  disconnectClient,
}) => {
  const { isAuth: token } = useContext(Context)
  const [vmDetails, setVmDetails] = useState(null)
  const [vmState, setVmState] = useState(null)
  const [tooltipVisible, setTooltipVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [, setHiddenButton] = useState(false)

  const fetchVmDetails = async () => {
    try {
      const details = await VirtualMachineService.getVMDetails(vmName, token)
      setVmDetails(details)
      setVmState(details.vm_details.power_state)
      updateVmDetails(details)
    } catch (err) {
      console.error('Error fetching VM details:', err.message)
    }
  }

  const handleAction = async (action) => {
    setIsLoading(true)
    try {
      const actions = {
        powerOn: VirtualMachineService.powerOn,
        powerOff: VirtualMachineService.powerOff,
        reset: VirtualMachineService.reset,
        suspend: VirtualMachineService.suspend,
      }

      if (actions[action]) {
        // const response = await actions[action](vmName, token)
        /* console.log(`${action} response:`, response); */
        if (action === 'powerOff');
        fetchVmDetails()
        disconnectClient()
        if (action === 'powerOn') fetchVmDetails()
        shoudlReconnect()
      }
    } catch (error) {
      console.error(`Error during ${action}:`, error.message)
    } finally {
      setIsLoading(false)
    }
  }

  // Obtener el primer snapshot y revertir la VM
  const handleRevertToFirstSnapshot = async () => {
    setIsLoading(true)
    try {
      const firstSnapshot = await VirtualMachineService.getFirstSnapshot(vmName, token)

      if (firstSnapshot) {
        // Revertir la VM al primer snapshot
        await VirtualMachineService.revertSnapshot(vmName, firstSnapshot, token)
        fetchVmDetails()
      } else {
        console.warn('No se encontraron snapshots para esta máquina virtual.')
      }
    } catch (error) {
      console.error('Error al revertir al primer snapshot:', error.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (vmName && token && isConnected) fetchVmDetails()
    if (!isConnected) setVmDetails(null)
  }, [vmName, token, isConnected, onStateMessage])

  useEffect(() => {
    if (vmDetails === null) {
      setHiddenButton(true)
    } else {
      setHiddenButton(false)
    }
  }, [vmDetails])

  return (
    <>
      {isLoading ? (
        <div className="loading-container">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em' }}></i>
        </div>
      ) : (
        <div className="remote-client-manager">
          {isConnected & (vmState === 'poweredOn') ? (
            <>
              <div className="circle-buttons">
                <div className="tooltip-container">
                  <button
                    onMouseEnter={() => setTooltipVisible(true)}
                    onMouseLeave={() => setTooltipVisible(false)}
                    title="Details"
                  >
                    <FaInfoCircle />
                  </button>
                  {tooltipVisible && vmDetails && (
                    <div className="tooltip">
                      <p>
                        <strong>Name:</strong> {vmDetails.vm_details.name}
                      </p>
                      <p>
                        <strong>State:</strong> {vmDetails.vm_details.power_state}
                      </p>
                      <p>
                        <strong>OS:</strong> {vmDetails.vm_details.guest_os}
                      </p>
                      <p>
                        <strong>CPU:</strong> {vmDetails.vm_details.cpu_count}
                      </p>
                      <p>
                        <strong>Memory:</strong> {vmDetails.vm_details.memory_mb} MB
                      </p>
                      <p>
                        <strong>IP:</strong> {vmDetails.vm_details.ip_address}
                      </p>
                      <p>
                        <strong>Notes:</strong> {vmDetails.vm_details.notes || 'N/A'}
                      </p>
                    </div>
                  )}
                </div>
                <button onClick={() => handleAction('powerOff')} title="Apagar">
                  <FaPowerOff />
                </button>
                <button onClick={() => handleAction('reset')} title="Reiniciar">
                  <FaRedo />
                </button>
                <button onClick={() => handleAction('suspend')} title="Suspender">
                  <FaPause />
                </button>
                <button onClick={() => handleRevertToFirstSnapshot()} title="Revertir">
                  <FaUndo />
                </button>
              </div>
            </>
          ) : (
            <div className={`circle-buttons`}>
              {/* <p>Disconnected</p> */}
              <button onClick={() => handleAction('powerOn')} title="Encender">
                <FaPowerOff />
              </button>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default RemoteClientManager
